var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("ProjectViewAdditionalFilters", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showAdditionalFilters,
            expression: "showAdditionalFilters",
          },
        ],
        attrs: {
          currentUserRole: _vm.currentUser.role,
          shouldClearFilters: _vm.shouldClearFilters,
        },
        on: {
          filtersChanged: _vm.handleFiltersChanged,
          appliedFiltersNumberChanged: _vm.handleAppliedFiltersNumberChanged,
          showActivitiesToggle: _vm.handleShowActivitiesToggle,
          filtersReset: function ($event) {
            return _vm.$emit("filtersReset")
          },
          rangeStart: _vm.handleTimeRangeChanged,
          rangeEnd: _vm.handleTimeRangeChangedEnd,
          close: _vm.handleIconClose,
        },
      }),
      _c(
        "LoadingOverlay",
        {
          staticClass: "w-full",
          attrs: {
            customPlaceholderMessage: _vm.customPlaceholderMessage,
            loading: _vm.loading,
            hasData: !!_vm.projects.length,
          },
        },
        [
          _vm.projects
            ? _c("Scheduler", {
                ref: "timeline",
                staticClass: "mb-10",
                attrs: {
                  groups: _vm.projectGroups,
                  items: _vm.projectItems,
                  customOptions: _vm.options,
                  currentUser: _vm.currentUser,
                },
                on: {
                  rangechanged: _vm.rangeChanged,
                  select: _vm.handleSelect,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "group",
                      fn: function ({ group }) {
                        return [
                          group
                            ? _c("ProjectGroup", {
                                staticClass: "w-full flex",
                                attrs: { name: group.name, id: group.id },
                              })
                            : _vm._e(),
                        ]
                      },
                    },
                    {
                      key: "item",
                      fn: function ({ item }) {
                        return [
                          item &&
                          item.entity !== _vm.schedulerItemEntities.MANAGER
                            ? _c("ProjectViewActivityItem", {
                                staticClass: "w-full flex",
                                attrs: { activity: item },
                                on: { create: _vm.handleCreateBtnClicked },
                              })
                            : _vm._e(),
                          item &&
                          item.entity === _vm.schedulerItemEntities.MANAGER
                            ? _c("ProjectViewProjectItem", {
                                attrs: {
                                  projectItem: item,
                                  currentUserId: _vm.currentUser.id,
                                },
                              })
                            : _vm._e(),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2960703023
                ),
              })
            : _vm._e(),
          _vm.showProjectModal
            ? _c("ProjectModal", {
                attrs: {
                  companyId: _vm.companyId,
                  currentUser: _vm.currentUser,
                  data: _vm.projectInfoForModal,
                  isEdittingLocked: _vm.isEdittingLocked,
                },
                on: {
                  close: _vm.handleCloseModal,
                  projectUpdated: _vm.refetchCollection,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "customHeader",
                      fn: function ({ title }) {
                        return [
                          _c("SchedulerCustomModalHeader", {
                            attrs: {
                              linkObject: _vm.linkToProject,
                              buttonText: title,
                              isEdittingLocked: _vm.isEdittingLocked,
                            },
                            on: { editClicked: _vm.handleEditClick },
                          }),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1916270658
                ),
              })
            : _vm._e(),
          _vm.showActivityModal
            ? _c("ActivityFormModal", {
                attrs: {
                  showDialog: _vm.modalShown,
                  project: _vm.projectInfoForModal,
                  projectActivity: _vm.activityInfoForModal,
                  isEdittingLocked: _vm.shouldBlockEditting,
                  currentUserRole: _vm.currentUser.role,
                  companyId: _vm.companyId,
                },
                on: {
                  close: _vm.handleCloseModal,
                  activityUpdated: _vm.handleCollectionUpdated,
                  activityAdded: _vm.handleCollectionUpdated,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "customHeader",
                      fn: function ({ title }) {
                        return [
                          _c("SchedulerCustomModalHeader", {
                            attrs: {
                              linkObject: _vm.linkToProjectActivities,
                              buttonText: title,
                              isEdittingLocked: _vm.shouldBlockEditting,
                              linkText: "Go To Project Tasks List",
                            },
                            on: { editClicked: _vm.handleEditClick },
                          }),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1846934760
                ),
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }